import HNSColors from "../../../../../../../ui library/HNSColors";

export const titleTypography = {
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "100%",
  letterSpacing: "0",
  color: HNSColors.primary[500],
  verticalAlign: "middle",
};

const Title = ({ children }) => {
  return (
    <div id="report-title" data-testid="report-title">
      <h1 className="text-left" style={titleTypography}>
        Reports: {children}
      </h1>
    </div>
  );
};
export default Title;
